import { z } from 'zod';
import { ApiMethod } from '../types/api.types';

export const API_TOKEN_RECURSIVE_CONTENT = {
    POST: {
        method: ApiMethod.POST,
        path: '/workspaces/:workspaceName/tokens/recursive-content/folders/:folderUuid',
        handlerMethod: 'createRecursiveFolderContentToken',
        zod: {
            params: z.object({
                workspaceName: z.string(),
                folderUuid: z.string()
            })
        },
        responses: {
            200: {
                description: 'Token created',
                schema: z.object({
                    token: z.string().uuid()
                })
            }
        }
    },
    GET: {
        method: ApiMethod.GET,
        path: '/tokens/recursive-content/:token',
        handlerMethod: 'useRecursiveFolderContentToken',
        isPublic: true,
        zod: {
            params: z.object({
                token: z.string().uuid()
            })
        }
    }
} as const;
